// Application configuration constants
// These values can be overridden by environment variables

export const APP_CONFIG = {
  // Task display settings
  TASK_DISPLAY_LIMIT: 100,
  
  // Cost and resource settings
  DEFAULT_DAILY_COST: parseInt(import.meta.env.VITE_DEFAULT_DAILY_COST || '5000000'),
  MAX_PERSONIL_CAPACITY: parseInt(import.meta.env.VITE_MAX_PERSONIL_CAPACITY || '500'),
  
  // Critical task threshold
  CRITICAL_TASK_WEIGHT_THRESHOLD: parseInt(import.meta.env.VITE_CRITICAL_TASK_WEIGHT_THRESHOLD || '2'),
  
  // Query caching
  TASKS_QUERY_STALE_TIME: 5 * 60 * 1000, // 5 minutes
  KPI_QUERY_STALE_TIME: 10 * 60 * 1000, // 10 minutes
  
  // Task name display
  TASK_NAME_MAX_LENGTH: 30
};

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  TIMEOUT: 10000 // 10 seconds
};

// Helper to get config value with fallback
export function getConfig<T>(key: keyof typeof APP_CONFIG, fallback?: T): T | typeof APP_CONFIG[keyof typeof APP_CONFIG] {
  const value = APP_CONFIG[key as keyof typeof APP_CONFIG];
  return value !== undefined ? value : (fallback as T);
}